import { requests, Requests } from './requests';

export const api: Requests = requests;
